import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { InputComponent } from '../input/input.component';
import { ButtonComponent } from '../button/button.component';
import { CommonService } from '../../services/common.service';
import { InputCheckboxComponent } from "../input-checkbox/input-checkbox.component";
import { InputPhoneComponent } from '../input-phone/input-phone.component';
import { MatDialog } from '@angular/material/dialog';
import { EmailVerificationModalComponent } from '../email-verification-modal/email-verification-modal.component';
import { UserService } from '../../services/user.service';
import { User } from '../../interfaces/user';
import { TranslateModule } from '@ngx-translate/core';

import { SkeletonComponent } from '../skeleton/skeleton.component';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule, InputComponent, ButtonComponent, InputPhoneComponent, TranslateModule, SkeletonComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent {
  isLoadingName:boolean = false
  errorMessageName:string = ''
  successMessageName:string = ''
  nameForm = new FormGroup({
    name: new FormControl('',[Validators.required,Validators.minLength(6)]),
  })

  isLoadingPassword:boolean = false
  errorMessagePassword:string = ''
  successMessagePassword:string = ''
  passwordForm = new FormGroup({
    oldPassword: new FormControl('',[Validators.required]),
    newPassword: new FormControl('',[Validators.required,Validators.minLength(6)]),
    confirmPassword: new FormControl('',[Validators.required]),
  })
  isAuthenticated = false;

  isLoading:boolean = false
  userInfo:any

  isLoadingPhone:boolean = false
  errorMessagePhone:string = ''
  successMessagePhone:string = ''
  phoneForm = new FormGroup({
    phone: new FormControl(null,[Validators.required]),
  })

  activeTab: 'profile' | 'security' = 'profile';
  showNameForm = false;
  showPasswordForm = false;
  showPhoneForm = false;

  isLoadingUnlink: string | null = null;
  errorMessageSocial = '';
  successMessageSocial = '';

  sessions: any[] = [];
  isLoadingSessions = false;
  isRevokingSession: string | null = null;
  isRevokingAll = false;
  sessionsLoaded = false;
  errorMessageSessions = '';
  successMessageSessions = '';

  constructor(
    private userService: UserService,
    private router: Router,
    private commonService: CommonService,
    private dialog: MatDialog,
    private authService: AuthService
  ) {}

  ngOnInit(){
    this.authService.getTokenChanges().subscribe(token => {
      this.isAuthenticated = !!token;
    });
    this.loadProfile()
  }

  loadProfile(){
    this.isLoading = true
    this.authService.getProfile().subscribe({
      next: (res) => {
      this.isLoading = false
        this.userInfo = res;
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Error paying reservation:', error);
      }
    });
  }

  onSubmitName() {
    this.nameForm.markAllAsTouched();
    this.commonService.markFormGroupDirty(this.nameForm)
    if (this.nameForm.valid) {
      this.isLoadingName = true;
      this.errorMessageName = '';
      this.successMessageName = '';
      const { name} = this.nameForm.value;

      if(!name) return 

      this.userService.updateName(name).subscribe(
        (response) => {
          this.isLoadingName = false;
          this.successMessageName = 'Se ha cambiado el nombre exitosamente.';
          this.loadProfile()

          // this.openVerificationModal(email)

          // this.router.navigate(['/login']);
        },
        (error) => {
          console.error('Error durante el cambio de nobmre:', error);
          this.isLoadingName = false;
          this.errorMessageName = error.error.message ?? 'Error al cambiar nombre. Por favor, inténtalo de nuevo.';
        }
      );
    }
  }


  onSubmitPhone() {

    this.phoneForm.markAllAsTouched();
    this.commonService.markFormGroupDirty(this.phoneForm)


    if (this.phoneForm.valid) {
      let number = ''
      const phoneObject = this.phoneForm.get('phone')?.value
      if(phoneObject){
        number = phoneObject['e164Number'];
      }
      this.isLoadingPhone = true;
      this.errorMessagePhone = '';
      this.successMessagePhone = '';

      if(!number) return 

      this.userService.updatePhone(number).subscribe(
        (response) => {
          this.isLoadingPhone = false;
          this.successMessagePhone = 'Se ha cambiado el telefono exitosamente.';
          this.loadProfile()
        },
        (error) => {
          console.error('Error durante el cambio de telefono:', error);
          this.isLoadingPhone = false;
          this.errorMessagePhone = error.error.message ?? 'Error al cambiar telefono. Por favor, inténtalo de nuevo.';
        }
      );
    }
  }

  onSubmitPassword() {
    this.passwordForm.markAllAsTouched();
    this.commonService.markFormGroupDirty(this.passwordForm)
    if (this.passwordForm.valid) {
      const { oldPassword, newPassword, confirmPassword } = this.passwordForm.value;
      
      this.isLoadingPassword = true;
      this.errorMessagePassword = '';
      this.successMessagePassword = '';

      if(!oldPassword || !newPassword || !confirmPassword) return
      if(newPassword != confirmPassword){
        this.isLoadingPassword = false;
        this.errorMessagePassword = 'Contraseñas no coinciden';
        return
      }

      this.userService.updatePassword(oldPassword, newPassword).subscribe(
        (response) => {
          this.isLoadingPassword = false;
          this.successMessagePassword = 'Se ha cambiado la contraseña exitosamente.';
          this.passwordForm.reset()
          this.loadProfile()

        },
        (error) => {
          console.error('Error al solicitar cambio de contraseña:', error);
          this.isLoadingPassword = false;
          this.errorMessagePassword = error.error.message ?? 'Error al cambiar contraseña. Por favor, inténtalo de nuevo.';
        }
      );
    }
  }

  onUnlinkProvider(provider: string): void {
    this.isLoadingUnlink = provider;
    this.errorMessageSocial = '';
    this.successMessageSocial = '';
    this.authService.unlinkProvider(provider).subscribe({
      next: () => {
        this.isLoadingUnlink = null;
        this.successMessageSocial = `Cuenta de ${provider} desvinculada exitosamente.`;
        this.loadProfile();
      },
      error: (err) => {
        this.isLoadingUnlink = null;
        this.errorMessageSocial = err?.error?.message ?? 'Error al desvincular. Intentá de nuevo.';
      }
    });
  }

  loadSessions(): void {
    this.isLoadingSessions = true;
    this.errorMessageSessions = '';
    this.authService.getSessions().subscribe({
      next: (res) => {
        const currentSessionId = this.authService.getSessionId();
        this.sessions = res
          .map((s: any) => ({ ...s, isCurrent: s.id === currentSessionId, parsedDevice: this.parseUserAgent(s.deviceInfo) }))
          .sort((a: any, b: any) => (b.isCurrent ? 1 : 0) - (a.isCurrent ? 1 : 0));
        this.sessionsLoaded = true;
        this.isLoadingSessions = false;
      },
      error: () => {
        this.isLoadingSessions = false;
        this.errorMessageSessions = 'Error al cargar sesiones.';
      }
    });
  }

  private parseUserAgent(ua: string): { browser: string; os: string; icon: string } {
    if (!ua) return { browser: 'Desconocido', os: 'Desconocido', icon: '🖥️' };

    let browser = 'Desconocido';
    let os = 'Desconocido';
    let icon = '🖥️';

    // OS
    if (/iPhone|iPad/.test(ua)) { os = /iPhone/.test(ua) ? 'iPhone' : 'iPad'; icon = '📱'; }
    else if (/Android/.test(ua)) { os = 'Android'; icon = '📱'; }
    else if (/Windows/.test(ua)) { os = 'Windows'; }
    else if (/Mac OS X/.test(ua)) { os = 'macOS'; }
    else if (/Linux/.test(ua)) { os = 'Linux'; }

    // Browser
    if (/Edg\//.test(ua)) browser = 'Edge';
    else if (/OPR\/|Opera/.test(ua)) browser = 'Opera';
    else if (/Brave/.test(ua)) browser = 'Brave';
    else if (/Chrome\//.test(ua)) browser = 'Chrome';
    else if (/Firefox\//.test(ua)) browser = 'Firefox';
    else if (/Safari\//.test(ua) && !/Chrome/.test(ua)) browser = 'Safari';

    return { browser, os, icon };
  }

  revokeSession(id: string): void {
    this.isRevokingSession = id;
    this.errorMessageSessions = '';
    this.authService.revokeSession(id).subscribe({
      next: () => {
        this.sessions = this.sessions.filter(s => s.id !== id);
        this.isRevokingSession = null;
        this.successMessageSessions = 'Sesión cerrada.';
      },
      error: () => {
        this.isRevokingSession = null;
        this.errorMessageSessions = 'Error al revocar sesión.';
      }
    });
  }

  revokeAllSessions(): void {
    this.isRevokingAll = true;
    this.errorMessageSessions = '';
    this.authService.revokeAllSessions().subscribe({
      next: () => {
        this.sessions = [];
        this.isRevokingAll = false;
        this.successMessageSessions = 'Todas las sesiones han sido cerradas.';
        this.authService.logout();
      },
      error: () => {
        this.isRevokingAll = false;
        this.errorMessageSessions = 'Error al revocar sesiones.';
      }
    });
  }
}
